export default "__VITE_ASSET__Baj93VRh__"